const PRICE_ROLES = ['admin', 'gly', 'xmcgy', 'fxmcgy', 'zjl']

export function hasPurchasePriceAccess(roles) {
  return (Array.isArray(roles) ? roles : []).some(role => {
    if (role && typeof role === 'object' && role.status != null && String(role.status) !== '0') return false
    const key = role && typeof role === 'object' ? role.roleKey : role
    return PRICE_ROLES.includes(String(key || '').trim().toLowerCase())
  })
}

export function isPurchasePricePath(path) {
  return /(?:^|\/)procurement\/price\/?$/.test(String(path || '').split('?')[0])
}

export function filterPurchasePriceMenus(routes, roles, parent = '') {
  return (routes || []).filter(route => {
    const path = String(route.path || '')
    return !isPurchasePricePath(path.startsWith('/') ? path : parent + '/' + path) || hasPurchasePriceAccess(roles)
  }).map(route => {
    const path = String(route.path || '')
    const fullPath = path.startsWith('/') ? path : parent + '/' + path
    return { ...route, ...(route.children ? { children: filterPurchasePriceMenus(route.children, roles, fullPath) } : {}) }
  })
}
